import * as React from 'react'
import createSvgIcon from './createSvgIcon'

export default createSvgIcon(
  <React.Fragment>
    <g clipPath="url(#clip0_1174_1003)">
      <rect width="16" height="16" rx="8" fill="currentColor" />
      <path
        d="M8.02051 11.999C8.0381 11.9987 8.05568 11.9983 8.07324 11.9971C8.09094 11.9958 8.10854 11.9944 8.12598 11.9922C8.14301 11.99 8.15983 11.9864 8.17676 11.9834C8.18653 11.9817 8.19638 11.9805 8.20605 11.9785C8.23359 11.9727 8.26102 11.9661 8.28809 11.958C8.29173 11.9569 8.2952 11.9552 8.29883 11.9541C8.31659 11.9486 8.33407 11.9421 8.35156 11.9355C8.36762 11.9295 8.38376 11.9238 8.39941 11.917C8.48309 11.8806 8.56261 11.8319 8.63574 11.7715C8.66048 11.7511 8.68438 11.7297 8.70703 11.707L11.707 8.70703C12.0973 8.31649 12.0975 7.68342 11.707 7.29297C11.3166 6.90254 10.6835 6.90266 10.293 7.29297L9 8.58594V5C9 4.44775 8.55223 4.00006 8 4C7.44772 4 7 4.44772 7 5V8.58594L5.70703 7.29297C5.31658 6.90254 4.6835 6.90266 4.29297 7.29297C3.90245 7.68349 3.90247 8.31651 4.29297 8.70703L7.29297 11.707C7.33824 11.7523 7.38719 11.7941 7.44043 11.8301C7.493 11.8656 7.54847 11.8955 7.60547 11.9199C7.64937 11.9388 7.69531 11.9533 7.74219 11.9658C7.75876 11.9702 7.77525 11.975 7.79199 11.9785C7.80296 11.9808 7.8141 11.9824 7.8252 11.9844C7.84271 11.9875 7.8603 11.99 7.87793 11.9922C7.8957 11.9943 7.9136 11.9959 7.93164 11.9971C7.94758 11.9982 7.96352 11.9987 7.97949 11.999C7.98628 11.9992 7.99318 12 8 12C8.00686 12 8.01368 11.9992 8.02051 11.999Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_1174_1003">
        <rect width="16" height="16" rx="8" fill="white" />
      </clipPath>
    </defs>
  </React.Fragment>,
  'TrendDownNegative'
)
